import { Box, Grid, Skeleton, Typography, useTheme } from "@mui/material";
import BusinesslistItem from "app/components/BusinessList/BusinesslistItem";
import ListHeader from "app/components/BusinessList/ListHeader";
import SelectedBusinessListView from "app/components/BusinessList/SelectedBusinessListView";
import { useGetBusinessListByUserIdQuery } from "lib/features/businessList/businessListService";
import { BusinessList as List } from "lib/features/businessList/types";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const BusinessList = () => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const [selectedBusiness, setSelectedBusiness] = useState<List>();

  const {
    data: businessListData,
    error: businessListError,
    isLoading: businessListLoading,
  } = useGetBusinessListByUserIdQuery({
    id: Number(id),
  });

  const headerBtnAction = () => {
    navigate(`/businesslist/create/${id}`);
  };

  const renderLoadingState = () => (
    <Grid container spacing={2}>
      {Array.from({ length: 8 }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Skeleton variant="rectangular" width="100%" height={50} />
        </Grid>
      ))}
    </Grid>
  );

  const renderErrorState = () => (
    <Typography textAlign={"center"} variant="subtitle1">
      Internal Server Error
    </Typography>
  );

  const renderBusinessList = () => (
    <Grid container spacing={2}>
      {businessListData &&
        businessListData?.length > 0 &&
        businessListData.map((business) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={business.id}>
            <BusinesslistItem
              business={business}
              setSelectedBusiness={setSelectedBusiness}
            />
          </Grid>
        ))}
    </Grid>
  );

  const renderNoRecordFound = () => (
    <Typography textAlign={"center"} variant="subtitle1">
      No Record Found
    </Typography>
  );

  return (
    <Box margin="1rem" fontFamily={theme.typography.fontFamily}>
      {/* Header */}
      <ListHeader
        isBackOnly={!!selectedBusiness}
        onBackPress={() => setSelectedBusiness(undefined)}
        headerBtnAction={headerBtnAction}
        headerTitle="Share Multiple Businesses"
        headerHeadline="Create custom business lists for specific activities or groups,
                      like “Bachelorette Parties” or “Party Boats.” to share with your
                      customers!"
        btnTitle="Create New List"
      />

      {/* List Cards */}
      <Box marginY={2}>
        {businessListLoading ? (
          renderLoadingState()
        ) : businessListError ? (
          renderErrorState()
        ) : selectedBusiness ? (
          <SelectedBusinessListView selectedBusiness={selectedBusiness} />
        ) : businessListData && businessListData.length > 0 ? (
          renderBusinessList()
        ) : (
          renderNoRecordFound()
        )}
      </Box>
    </Box>
  );
};

export default BusinessList;
